const actionTypeIdentifier = 'b65af91e-a561-4e53-96cb-08cb03e95089';
export const getVendorDetails  = `INVOICE-GET-Vendor-DETAILS-${actionTypeIdentifier}`;
export const getInvoiceMaster = `INVOICE-GET-INVOICE-MASTER-${actionTypeIdentifier}`;
export const getBillingAccount = `INVOICE-GET-BILLING-ACCOUNT-${actionTypeIdentifier}`;
export const setInvoiceUploadError = `INVOICE-SET-INVOICE-UPLOAD-ERROR-${actionTypeIdentifier}`;
export const getInvoiceMasterConfig = `INVOICE-GET-INVOICE-MASTER-CONFIG=${actionTypeIdentifier}`;

export const InvoiceUploadModel = {
    vendorId:0,
    invoiceMasterId:0,
    financeAccountId:0,
    invoiceDate:null,
    invoiceNumber: "",
    fanChargesAndCredits: "0.00",
    creditNote: false,
    files: [],
    autresServices: ""
}